import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteShopSupplierDocument,
  DeleteShopSupplierMutation,
} from "../generated-graphql/graphql";

const deleteBulkAction: BulkAction = {
  location: "shop-supplier-table",
  label: "Delete Selected Supplier",
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) =>
    userPermissions.includes("DeleteSupplier"),
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const notificationService = injector.get(NotificationService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Selected Suppliers",
        body: `Are you sure you want to delete ${selection.length} supplier?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteShopSupplierMutation>[] =
            [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteShopSupplierDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe((res) => {
            console.log(res);
            let deletedCount = 0;
            res.forEach((r) => {
              const { deleteShopSupplier } = r;
              if (deleteShopSupplier.result === "DELETED") {
                deletedCount++;
              }
              if (deletedCount > 0) {
                notificationService.success(
                  `Deleted ${deletedCount} suppliers`
                );
              }
            });

            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
